import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Handle } from "reactflow";
import * as Yup from "yup";
import "./flowStyle.css";

const CustomNode = ({ id, data }) => {
  const { t } = useTranslation();
  const inputId = "input-" + id;
  const outputId = "output-" + id;
  const [open, setOpen] = useState(false);

  const initialValues = {
    uid: data?.uid ?? "",
    name: data?.label ?? "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (value) => {
    data.onEdit(id, value);
    setOpen(false);
  };

  return (
    <div className="custom-node">
      <div className="inputs">
        <Handle key={inputId} type="target" position="left" />
      </div>
      <div className="content">
        <div className="buottons-container">
          <button className="custom-node-button" onClick={handleClickOpen}>
            <div>i</div>
          </button>
          <button
            className="custom-node-button"
            onClick={() => data.onRemove(id)}
          >
            <div>x</div>
          </button>
        </div>
        <div>{data.label}</div>
      </div>
      <div className="outputs">
        <Handle key={outputId} type="source" position="right" />
      </div>
      <Dialog open={open} onClose={handleClose}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSave}
        >
          {(formikDialogProps) => (
            <Form>
              <DialogTitle>{t("custom-node.dialog-title")}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t("custom-node.dialog-content-text")}
                </DialogContentText>
                <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                  <Field
                    autoFocus
                    as={TextField}
                    label={t("custom-node.flow-node-name")}
                    name="name"
                    variant="outlined"
                    fullWidth
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="error-message"
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>{t("cancel")}</Button>
                <Button type="submit" variant="contained" color="primary">
                  {t("save")}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default CustomNode;
